import React, { createContext, useState, useEffect } from "react";
import Loader from "../components/Loader";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const addToCart = (item) => {
    if (isInCart(item.id)) {
      sumarCantidad(item);
    } else {
      setCart([...cart, { ...item }]);
    }
  };

  const isInCart = (id) => {
    return cart.some((producto) => producto.id === id);
  };

  const sumarCantidad = (item, cantidad, formaPago) => {
    const cartActualizado = cart.map((producto) => {
      if (producto.id === item.id) {
        return {
          ...producto,
          cantidad: cantidad,
          formaPago: formaPago,
        };
      } else {
        return producto;
      }
    });
    setCart(cartActualizado);
  };

  const clearCart = () => {
    setCart([]);
  };

  const clearProducto = (id) => {
    const cartFiltrado = cart.filter((producto) => producto.id !== id);
    setCart(cartFiltrado);
  };

  const totalCart = () => {
    const copyCart = [...cart];
    let acumulador = 0;
    copyCart.forEach((producto) => {
      acumulador += producto.cantidad;
    });
    return acumulador;
  };

  const totalPrecio = () => {
    const copyCart = [...cart];
    let acumulador = 0;
    copyCart.forEach((producto) => {
      acumulador += producto.cantidad * producto.precio;
    });
    return acumulador;
  };

  const cantidadSeleccionada = (id) => {
    const producto = cart.find((prod) => prod.id === id);
    return producto?.cantidad;
  };

  const handleModal = () => {
    setShowModal(!showModal);
  };

  useEffect(() => {
    const loadProducts = async () => {
      try {
        // Hacemos el fetch directo a la carpeta public
        const response = await fetch("/tienda/productos.json");
        if (!response.ok) {
          throw new Error("No se pudo cargar el catálogo de productos");
        }
        const data = await response.json();

        // Replicamos el filtro (estado === "activo") y el orden (por título) de Firebase
        const productosProcesados = data
          .filter((prod) => prod.estado === "activo")
          .sort((a, b) => a.titulo.localeCompare(b.titulo));

        setItems(productosProcesados);
      } catch (error) {
        console.error("Error al traer los productos:", error);
      } finally {
        setIsLoading(false);
      }
    };

    loadProducts();
  }, []);

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        clearCart,
        clearProducto,
        totalCart,
        totalPrecio,
        cantidadSeleccionada,
        handleModal,
        items,
      }}
    >
      {isLoading ? (
        <div className="loader-container">
          <div className="loader">
            <Loader />
          </div>
        </div>
      ) : (
        children
      )}
    </CartContext.Provider>
  );
};
